import { html as t, when as o } from "@microsoft/fast-element";
const r = t`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="matrix(-1 0 0 1 24 0)"
      fill="none"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.89999 19.9H4.49999C3.17451 19.9 2.09999 18.8255 2.09999 17.5V6.49998C2.09999 5.17449 3.17451 4.09998 4.49999 4.09998H5.89999V19.9ZM7.39999 19.9L7.39999 4.09998H19.5C20.8255 4.09998 21.9 5.17449 21.9 6.49998V17.5C21.9 18.8255 20.8255 19.9 19.5 19.9H7.39999Z"
      fill="currentColor"
    />
  </svg>
`, l = t`
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="matrix(-1 0 0 1 24 0)"
      fill="none"
    />
    <rect
      width="18"
      height="14"
      rx="1.5"
      transform="matrix(-1 0 0 1 21 5)"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="6.75"
      y1="18.25"
      x2="6.75"
      y2="5.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, i = t`
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="20"
      height="20"
      transform="matrix(-1 0 0 1 20 0)"
      fill="none"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.5 16.5833H3.75C2.64543 16.5833 1.75 15.6879 1.75 14.5833V5.41666C1.75 4.31209 2.64543 3.41666 3.75 3.41666H5.5L5.5 16.5833ZM7 16.5833L7 3.41666H16.25C17.3546 3.41666 18.25 4.31209 18.25 5.41666V14.5833C18.25 15.6879 17.3546 16.5833 16.25 16.5833H7Z"
      fill="currentColor"
    />
  </svg>
`, n = t`
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="16"
      height="16"
      transform="matrix(-1 0 0 1 16 0)"
      fill="none"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.4 13.2667H2.99998C2.11632 13.2667 1.39998 12.5503 1.39998 11.6667V4.33334C1.39998 3.44968 2.11632 2.73334 2.99998 2.73334H4.4L4.4 13.2667ZM5.6 2.73334L5.6 13.2667H13C13.8836 13.2667 14.6 12.5503 14.6 11.6667V4.33334C14.6 3.44968 13.8836 2.73334 13 2.73334H5.6Z"
      fill="currentColor"
    />
  </svg>
`, h = t`
  ${o((e) => e._type === "outline", l)}
  ${o((e) => e._type === "solid", r)}
  ${o((e) => e._type === "mini", i)}
  ${o((e) => e._type === "micro", n)}
`;
export {
  h as dockLeftTemplate
};
